<div style="margin: 15px;">
  <h1>{{ 'ACCESSIBILITY.TITLE' | translate }}</h1>
  <p style="text-align:center;">{{ 'ACCESSIBILITY.UPDATED_DATE' | translate }}</p>
  <p style="text-align:justify;"><span style="color:rgb(51, 51, 51);">{{ 'ACCESSIBILITY.INTRO' | translate }}</span></p>
  <h2>{{ 'ACCESSIBILITY.WHAT_IS_TITLE' | translate }}</h2>
  <p style="text-align:justify;"><span style="color:rgb(51, 51, 51);">{{ 'ACCESSIBILITY.WHAT_IS_DESC' | translate }}</span></p>
  <h2>{{ 'ACCESSIBILITY.ADJUSTMENTS_TITLE' | translate }}</h2>
  <p style="text-align:justify;"><span style="color:rgb(51, 51, 51);">{{ 'ACCESSIBILITY.ADJUSTMENTS_DESC' | translate }}</span></p>
  <p style="text-align:justify;"><span style="color:rgb(51, 51, 51);">{{ 'ACCESSIBILITY.KEYBOARD_SUPPORT' | translate }}</span></p>
  <p style="text-align:justify;"><span style="color:rgb(51, 51, 51);">{{ 'ACCESSIBILITY.TESTING_SCHEDULE' | translate }}</span></p>
  <h2>{{ 'ACCESSIBILITY.THIRD_PARTY_TITLE' | translate }}</h2>
  <p>{{ 'ACCESSIBILITY.THIRD_PARTY_DESC' | translate }}</p>
  <h2>{{ 'ACCESSIBILITY.OPTIMAL_TITLE' | translate }}</h2>
  <p style="text-align:justify;"><span style="color:rgb(51, 51, 51);">{{ 'ACCESSIBILITY.OPTIMAL_DESC' | translate }}</span></p>
  <h2>{{ 'ACCESSIBILITY.STAGES_TITLE' | translate }}</h2>
  <p style="text-align:justify;"><span style="color:rgb(51, 51, 51);">{{ 'ACCESSIBILITY.STAGES_DESC' | translate }}</span></p>
  <h2>{{ 'ACCESSIBILITY.ORG_TITLE' | translate }}</h2>
  <p>{{ 'ACCESSIBILITY.ORG_DESC' | translate }}</p>
  <h2>{{ 'ACCESSIBILITY.CONTACT_TITLE' | translate }}</h2>
  <p style="text-align:justify;"><span style="color:rgb(51, 51, 51);">{{ 'ACCESSIBILITY.CONTACT_DESC' | translate }}</span></p>
  <p style="text-align:justify;"><span style="color:rgb(51, 51, 51);">{{ 'ACCESSIBILITY.CONTACT_NAME' | translate }}</span></p>
  <p style="text-align:justify;"><span style="color:rgb(51, 51, 51);">050-6880102</span></p>
  <p style="text-align:justify;"><span style="color:rgb(51, 51, 51);">elad@slickchain.com</span></p>
</div>
